var _FrontendSchemaService_cachedSchemas;
import { __classPrivateFieldGet, __decorate, __metadata } from "tslib";
import { Injectable } from "@angular/core";
import { AxiosApiClient, SchemasApi } from "@smallstack/axios-api-client";
import { snakeCaseToCamelCase } from "@smallstack/utils";
import { plural } from "pluralize";
import { synchronized } from "synchronized-ts";
import * as i0 from "@angular/core";
import * as i1 from "@smallstack/axios-api-client";
export class FrontendSchemaService {
    constructor(axiosApiClient) {
        this.axiosApiClient = axiosApiClient;
        _FrontendSchemaService_cachedSchemas.set(this, {});
    }
    async getSchemaByName(name) {
        name = this.tidySchemaName(name);
        // Logger.info("FrontendSchemaService", "Getting schema by name: " + name);
        if (__classPrivateFieldGet(this, _FrontendSchemaService_cachedSchemas, "f")[name])
            return __classPrivateFieldGet(this, _FrontendSchemaService_cachedSchemas, "f")[name];
        else {
            const schema = await this.axiosApiClient
                .get(SchemasApi)
                .getSchema({ name })
                .then((res) => res.data);
            __classPrivateFieldGet(this, _FrontendSchemaService_cachedSchemas, "f")[name] = schema;
            return schema;
        }
    }
    async getAllSchemas() {
        if (Object.keys(__classPrivateFieldGet(this, _FrontendSchemaService_cachedSchemas, "f")).length === 0)
            await this.cacheAllSchemas();
        return __classPrivateFieldGet(this, _FrontendSchemaService_cachedSchemas, "f");
    }
    addSchemaToCache(name, schema) {
        __classPrivateFieldGet(this, _FrontendSchemaService_cachedSchemas, "f")[name] = schema;
    }
    tidySchemaName(schemaName) {
        return plural(snakeCaseToCamelCase(schemaName, false));
    }
    async cacheAllSchemas() {
        const allSchemas = await this.axiosApiClient
            .get(SchemasApi)
            .getAllSchemas()
            .then((res) => res.data);
        for (const key in allSchemas) {
            this.addSchemaToCache(key, allSchemas[key]);
        }
    }
}
_FrontendSchemaService_cachedSchemas = new WeakMap();
FrontendSchemaService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.5", ngImport: i0, type: FrontendSchemaService, deps: [{ token: i1.AxiosApiClient }], target: i0.ɵɵFactoryTarget.Injectable });
FrontendSchemaService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.5", ngImport: i0, type: FrontendSchemaService, providedIn: "root" });
__decorate([
    synchronized,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", Promise)
], FrontendSchemaService.prototype, "getSchemaByName", null);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.5", ngImport: i0, type: FrontendSchemaService, decorators: [{
            type: Injectable,
            args: [{ providedIn: "root" }]
        }], ctorParameters: function () { return [{ type: i1.AxiosApiClient }]; }, propDecorators: { getSchemaByName: [] } });
